import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../styles/components.css';

const SectionBanner = ({ title, tagline }) => {
    return (
        <section className='banner-gradient'>
            <Container>
                <Row>
                    <Col>
                        <h1>{title}</h1>
                        <p>{tagline}</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default SectionBanner;